// 话题直播类型
export const modelTypeEnum = {
  PICTURE_WORD: 0, // 图文直播
  VIDEO: 2, // 视频直播
  VOICE: 4, // 语音直播
  PICTURE: 5, // 图片直播
  SlOW: 6, // 慢直播(等于2视频模式，只是为了区别)
}

// 话题类型
export const tplNameEnum = {
  EntTVChat: 'EntTVChat', // 默认
  VRLive: 'VRLive', // VR全景直播
}

export const topicTypesEnum = {
  OPEN: 0, // 公开
  ENCRYPTION: 1, // 密码
  PAY: 2, // 付费
}

export const ROLEENUM = {
  USER: 0, // 访客
  CREATOR: 1, // 直播间创建者
  ADMIN: 2, // 直播间管理员
  GUEST: 3, // 嘉宾
  COMPERE: 4, // 主持人
  TOPICCREATOR: 5, // 话题创建者
  GROOM: 6, // 新郎
  BRIDE: 8, // 新娘
  VEROFOADMIN: 10, // 直播间核销员
  CHANELCREATE: 11, // 频道创建者
  CHANNELADMIN: 12, // 频道管理员
  CUSTOMROLE: 13, // 自定义角色
  TOPICADMIN: 14, // 话题管理员
  LIVEASSISTANT: 15, // 直播助理
  SUPERADMIN: 16, // 超级管理员
  ADMINORASSISTANT: 17, // 创建者或管理员或直播助理角色
  PICTURER: 18, // 图片直播修图师
  ULTRAVIRES: 20, // 门店越权
  ECOMMERCESPECIALIST: 22, // 电商专员
  0: 'USER',
  1: 'CREATOR',
  2: 'ADMIN',
  3: 'GUEST',
  4: 'COMPERE',
  5: 'TOPICCREATOR',
  6: 'GROOM',
  8: 'BRIDE',
  10: 'VEROFOADMIN',
  11: 'CHANNELADMIN',
  12: 'CHANELCREATE',
  13: 'CUSTOMROLE',
  14: 'TOPICADMIN',
  15: 'LIVEASSISTANT',
  16: 'SUPERADMIN',
  17: 'ADMINORASSISTANT',
  18: 'PICTURER',
  20: 'ULTRAVIRES',
  22: 'ECOMMERCESPECIALIST',
}

// 直播间版本
export const customerTypeEnum = {
  Broadcast: 99, // 广电版
}

export const applyIdEnum = {
  CHAIN_STORE: 16, // 连锁门店
  RIGHTS: 20, // 权益版
}

// 边买边看商品类型
export const proTypeEnum = {
  PRODUCT_OLD: 0, // 标准商品（旧数据）
  PRODUCT: 2, // 标准商品
  TOPIC: 3, // 直播
  CHANNEL: 4, // 频道
  IMAGE_TEXT: 5, // 图文
  AUDIO: 6, // 音频
  VIDEO: 7, // 视频
  COURSE: 8, // 课程
  SPECIAL: 9, // 专栏
  TRAIN_CAMP: 10, // 训练营
  VIP_CARD: 11, // 权益卡
}

export const proTypeMap = {
  0: '普通商品',
  2: '普通商品',
  3: '直播',
  4: '频道',
  5: '图文',
  6: '音频',
  7: '视频',
  8: '课程',
  9: '专栏',
  10: '训练营',
  11: '权益卡',
}

export function GetEnumName(obj, value) {
  return ((obj || []).find(p => p.value === value) || {}).label || ''
}
export const accountState = Object.freeze([
  { label: '全部', value: -99 },
  { label: '未开户', value: 0 },
  { label: '申请中', value: 1 }, // 已保存资料
  { label: '申请中', value: 2 },
  { label: '审核失败', value: 3 },
  { label: '审核失败', value: 5 },
  { label: '已开户', value: 6 }, // 审核成功
  { label: '审核中', value: 4 },
])
